import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const ExcelsiorHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title="New York State's Free College Initiative">
    The Excelsior Scholarship covers tuition for up to $5,500. To qualify, you must meet academic requirements (on track
    to graduate in 2 years for associate program and 4 years for bachelor's program) and family income requirements for
    2019-2020 ($125,000/year - AGI on 2017 tax return)
  </HelpModal>